import React from "react";
import { FaEnvelope, FaFacebookF, FaGlobe, FaInstagram, FaMapMarkerAlt, FaPhone } from "react-icons/fa";

import {
  getGalleryLabel,
  resolveMediaUrl,
  stripHtml,
} from "../utils/settingsManagerUtils";

export default function SettingsPreviewPanel({ settings, galleries }) {
  const logo = resolveMediaUrl(settings.logo_asso, "/images/asso_placeholder.webp");
  const header = resolveMediaUrl(
    settings.header1_photo_url,
    "/images/asso_placeholder.webp"
  );

  return (
    <div className="sticky top-5 space-y-4">
      <div className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-white/10 dark:bg-slate-900">
        <div
          className="h-36 bg-cover bg-center"
          style={{ backgroundImage: `url('${header}')` }}
        >
          <div className="flex h-full items-end bg-slate-950/50 p-4">
            <div>
              <p className="text-xs font-bold uppercase tracking-[0.18em] text-white/70">
                Aperçu accueil
              </p>

              <h3 className="mt-1 line-clamp-2 text-xl font-bold text-white">
                {stripHtml(settings.header_title) || "Titre de la page d’accueil"}
              </h3>
            </div>
          </div>
        </div>

        <div className="p-4">
          <p className="text-sm leading-6 text-slate-600 dark:text-slate-300">
            {settings.header_subtitle || "Sous-titre de présentation du portail."}
          </p>
        </div>
      </div>

      <div className="rounded-[28px] border border-slate-200 bg-white p-5 shadow-sm dark:border-white/10 dark:bg-slate-900">
        <div className="flex items-center gap-4">
          <div className="flex h-20 w-20 shrink-0 items-center justify-center overflow-hidden rounded-3xl bg-slate-100 p-2 dark:bg-slate-950">
            <img
              src={logo}
              alt={settings.nom_asso}
              className="max-h-full max-w-full object-contain"
              onError={(event) => {
                event.currentTarget.src = "/images/asso_placeholder.webp";
              }}
            />
          </div>

          <div className="min-w-0">
            <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-primary">
              Identité
            </p>

            <h3 className="mt-1 truncate text-lg font-bold text-slate-950 dark:text-white">
              {settings.nom_asso || "Nom du portail"}
            </h3>

            <p className="truncate text-sm text-slate-500 dark:text-slate-400">
              {settings.shortname_asso || "Nom court"}
            </p>
          </div>
        </div>

        <div className="mt-5 space-y-3 text-sm text-slate-600 dark:text-slate-300">
          <InfoLine icon={<FaMapMarkerAlt />} value={settings.adresse_asso} />
          <InfoLine icon={<FaPhone />} value={settings.tel_asso} />
          <InfoLine icon={<FaEnvelope />} value={settings.mail_asso} />
          <InfoLine icon={<FaGlobe />} value={settings.siteweb_asso} />
        </div>
      </div>

      <div className="rounded-[28px] border border-slate-200 bg-white p-5 shadow-sm dark:border-white/10 dark:bg-slate-900">
        <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-slate-500 dark:text-slate-400">
          Réseaux & carrousel
        </p>

        <div className="mt-4 flex flex-wrap gap-2">
          <SocialBadge icon={<FaFacebookF />} active={settings.facebook_asso}>
            Facebook
          </SocialBadge>

          <SocialBadge icon={<FaInstagram />} active={settings.instagram_asso}>
            Instagram
          </SocialBadge>
        </div>

        <div className="mt-4 rounded-2xl bg-slate-50 p-3 text-sm font-bold text-slate-700 dark:bg-slate-950 dark:text-slate-200">
          Galerie : {getGalleryLabel(galleries, settings.carrousel_id)}
        </div>

        <div className="mt-4 flex items-center gap-3 rounded-2xl bg-slate-50 p-3 dark:bg-slate-950">
          <span className="h-8 w-8 rounded-full border border-slate-200 dark:border-white/10" style={{ backgroundColor: settings.primary_color || "#013E8E" }} />
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.16em] text-slate-500 dark:text-slate-400">
              Couleur primaire
            </p>
            <p className="text-sm font-bold text-slate-900 dark:text-white">
              {settings.primary_color || "#013E8E"}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

function InfoLine({ icon, value }) {
  if (!value) return null;

  return (
    <div className="flex items-center gap-2">
      <span className="text-primary">{icon}</span>
      <span className="truncate">{value}</span>
    </div>
  );
}

function SocialBadge({ icon, active, children }) {
  return (
    <span
      className={[
        "inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-bold ring-1",
        active
          ? "bg-emerald-50 text-emerald-700 ring-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-300 dark:ring-emerald-500/20"
          : "bg-slate-100 text-slate-500 ring-slate-200 dark:bg-slate-800 dark:text-slate-400 dark:ring-slate-700",
      ].join(" ")}
    >
      {icon}
      {children}
    </span>
  );
}